import { useMemo } from 'react';

export type FeatureFlags = {
  useLangGraph: boolean;
  useGraphJobs?: boolean;
  langGraphTrafficPercent: number;
  disableLegacyChat?: boolean;
  showLegacyPressReleaseAnalyzer?: boolean;
  toolsUseAgents?: boolean;
  autoSaveArtifacts?: boolean;
  localeDefault?: 'en' | 'ar';
  crisisUseService?: boolean;
  enableResearcher?: boolean;
  enableMediaCRMNode?: boolean;
  enableOutreachSequencer?: boolean;
  enableCoverageTracker?: boolean;
  enableCrisisOrchestrator?: boolean;
  enableReputationMonitorUI?: boolean;
  enableOutreachIntelligence?: boolean;
  enableSupervisor?: boolean;
  useRedesignedButtons?: boolean;
  useRedesignedInputs?: boolean;
  useRedesignedCards?: boolean;
  useRedesignedNavigation?: boolean;
  useRedesignedChat?: boolean;
  useRedesignedPages?: boolean;
  rolloutPercentage?: number;
  forceRedesign?: boolean;
  showArtifactFormatPanels?: boolean;
  enableCrisisOpsDocs?: boolean;
  enableCrisisApprovalStub?: boolean;
};

const ALWAYS_ON_FLAGS: FeatureFlags = {
  useLangGraph: true,
  useGraphJobs: true,
  langGraphTrafficPercent: 100,
  disableLegacyChat: true,
  showLegacyPressReleaseAnalyzer: false,
  toolsUseAgents: true,
  autoSaveArtifacts: true,
  localeDefault: 'en',
  crisisUseService: true,
  enableResearcher: true,
  enableMediaCRMNode: true,
  enableOutreachSequencer: true,
  enableCoverageTracker: true,
  enableCrisisOrchestrator: true,
  enableReputationMonitorUI: true,
  enableOutreachIntelligence: true,
  enableSupervisor: true,
  useRedesignedButtons: true,
  useRedesignedInputs: true,
  useRedesignedCards: true,
  useRedesignedNavigation: true,
  useRedesignedChat: true,
  useRedesignedPages: true,
  rolloutPercentage: 100,
  forceRedesign: true,
  showArtifactFormatPanels: true,
  enableCrisisOpsDocs: true,
  enableCrisisApprovalStub: true,
};

export function useFeatureFlags() {
  const flags = useMemo<FeatureFlags>(() => ({ ...ALWAYS_ON_FLAGS }), []);
  return { flags, loaded: true, error: null as Error | null };
}

export function isUserInRollout(_userId: string | null | undefined, _flags: FeatureFlags): boolean {
  return true;
}
